import { getNames } from 'country-list';

const countryNames = getNames();
export default countryNames;
